export const DISPLAY_ITEM_TYPES = {
  DataSource: 'Source',
  DataSet: 'Nexset',
  DataSink: 'Destination',
  CodeContainer: 'Transform',
  DataSchema: 'Schema',
  AttributeTransform: 'Transform',
  DataCredentials: 'Credential',
  DataMap: 'Lookup',
  ExternalSharer: 'Share recipient',
  NotificationSetting: 'Notification setting',
};
